// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth.js';
import { SIGNUP_CLOSED } from '../utils/siteMode.js';

export default function ProtectedRoute({ children }) {
  const { user, profile, loading, profileLoaded } = useAuth();
  const location = useLocation();

  if (loading || (user && !profileLoaded)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-gray-500">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  if (!profile) {
    console.warn('[ProtectedRoute] user authenticated but no Firestore profile — redirecting to /register', {
      uid: user.uid, email: user.email, profileLoaded,
    });
    // 가입이 닫힌 뒤에는 /register 가 /login 으로 튕기므로 곧장 /login 으로 보낸다.
    return <Navigate to={SIGNUP_CLOSED ? '/login' : '/register'} state={{ from: location.pathname }} replace />;
  }

  return children;
}
